jQuery(document).ready(function () {
    jQuery('.icon-cancel-circle').click(function () {
        jQuery('#search-input').val('');
        jQuery('.search-form').addClass('active');
    })

    jQuery('#search-input').blur(function() {
        if (!jQuery('#search-input').val() ) {
            jQuery('.search-form').addClass('active');
        }

        if (jQuery(this).val()) {
            jQuery('.search-form').removeClass('active');
        }
    })
})